import React, { useState } from 'react';
import ModalWhatsApp from './ModalWhatsApp';

const WhatsAppButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        className="whatsapp-float"
        onClick={openModal}
        aria-label="Contactar por WhatsApp"
      >
        {/* Placeholder para icono de WhatsApp */}
        <span className="whatsapp-icon">💬</span>
      </button>

      <ModalWhatsApp isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default WhatsAppButton;
